import { usePostHog } from 'posthog-js/react';
import { useCallback, useRef } from 'react';
import { isDev } from '../../../lib/utils.ts';
import type {
    AnalyticsEventPayload,
    AnalyticsEvents,
    AnalyticsEventType,
} from '../types/analytics-events.ts';

export type SendEventArgs<T extends AnalyticsEventType> = undefined extends AnalyticsEvents[T]
    ? [event: T]
    : [event: T, payload: AnalyticsEventPayload<T>];

export type SendEventFn = <T extends AnalyticsEventType>(...args: SendEventArgs<T>) => void;

export function useAnalytics(): SendEventFn {
    const postHog = usePostHog();
    const postHogRef = useRef(postHog);

    return useCallback(<T extends AnalyticsEventType>(event: T, payload?: AnalyticsEventPayload<T>): void => {
        const postHog = postHogRef.current;

        if (isDev()) {
            if (payload) {
                console.groupCollapsed(
                    `%c📊 Event: ${event}%c`,
                    'color: white; background: #3b3b98; padding: 4px 8px; border-radius: 4px;',
                    'color: #f8a5c2; font-weight: bold;',
                );
                console.log(`%c ${JSON.stringify(payload, null, 2)}`, 'color: #f78fb3; font-weight: bold;');
                console.groupEnd();
            } else {
                console.log(
                    `%c📊 Event: ${event}%c`,
                    'color: white; background: #3b3b98; padding: 4px 8px; border-radius: 4px;',
                    'color: #f8a5c2; font-weight: bold;',
                );
            }
        }

        postHog.capture(event, payload);
    }, []);
}
